/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "E3151B2B-3667-4C02-8BF4-09DD81C31EEE",
  "sitecoreApiHost": "",
  "jssAppName": "hic",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/honda-canada",
  "graphQLEndpoint": "/api/honda-canada?sc_apikey=E3151B2B-3667-4C02-8BF4-09DD81C31EEE"
};